import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolLpAction } from '../symbolLp.action';

export const startSymbolLpProcessingEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolLpAction.create.started,
    SymbolLpAction.update.started,
    SymbolLpAction.remove.started,
  ),
  mergeMap(() => {
    return [
      SymbolLpAction.processing.started(),
    ];
  }),
);
